import { withProps } from 'recompose'

export default withProps({
  normalizeValue: ({ value } = {}) => value
})
